module.exports = __webpack_public_path__ + "static/media/jp.a9e3ae2d.svg";